module.exports = __webpack_public_path__ + "static/media/aafiya.375ade47.png";